import debounce from "debounce-promise";
import { ResolveEndpointType } from "healthex-common/fasten.epic.resolution.dtos";
import { RequestSupportInputType } from "healthex-common/request.support.dtos";
import { withoutUndefinedNullOrEmptyProperties } from "healthex-common/utils";
const SEARCH_DEBOUNCE_MILLISECONDS = 300;
const EMPTY_RESPONSE = {
    totalHits: 0,
    offset: 0,
    limit: 0,
    hasMore: false,
    searchMode: "name",
    results: [],
};
export const SearchAnalyticsEvent = {
    SEARCH_MODAL_OPENED: "SearchModalOpened",
    SEARCH_RESULT_SELECTED: "SearchResultSelected",
    SEARCH_SUGGESTION_SELECTED: "SearchSuggestionSelected",
    SEARCH_EPIC_LOOKUP_FAILED: "SearchEpicLookupFailed",
};
export class PatientPortalSearchManager {
    constructor(patientPortalSearchService, healthExSupportService, authManager, documentRetrievalManager) {
        this.patientPortalSearchService = patientPortalSearchService;
        this.healthExSupportService = healthExSupportService;
        this.authManager = authManager;
        this.documentRetrievalManager = documentRetrievalManager;
        this.search = debounce((criteria) => {
            return this.executeSearch(criteria);
        }, SEARCH_DEBOUNCE_MILLISECONDS);
        this.loadPage = (criteria) => {
            return this.executeSearch(criteria);
        };
    }
    async executeSearch(criteria) {
        var _a, _b, _c;
        try {
            const optionalFilters = withoutUndefinedNullOrEmptyProperties({
                city: (_a = criteria.city) === null || _a === void 0 ? void 0 : _a.trim(),
                state: criteria.state,
                zipcode: (_b = criteria.zipcode) === null || _b === void 0 ? void 0 : _b.trim(),
                platformType: criteria.platformType,
                limit: criteria.limit,
                offset: criteria.offset,
            });
            const batchId = (_c = this.documentRetrievalManager.retrieval) === null || _c === void 0 ? void 0 : _c.batchId;
            const inputPayload = {
                query: criteria.query,
                isSandbox: this.authManager.isSandbox,
                ...(batchId ? { batchId } : {}),
                ...optionalFilters,
            };
            return await this.patientPortalSearchService.search(inputPayload);
        }
        catch (error) {
            console.error("Patient portal search failed", error);
            return EMPTY_RESPONSE;
        }
    }
    async resolveEpicEndpoint(brandId, portalId, endpointId) {
        try {
            return await this.patientPortalSearchService.resolveEndpoint({
                type: ResolveEndpointType.EPIC,
                brandId,
                portalId,
                endpointId,
            });
        }
        catch (error) {
            console.error("Resolve Epic endpoint failed", error);
            return null;
        }
    }
    async requestProvider(query, patientId) {
        await this.healthExSupportService.requestSupport({
            type: RequestSupportInputType.REQUEST_A_PROVIDER,
            patientId,
            searchQuery: query,
        });
    }
}
